/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchDealsRequestSortingCriteria
 */
export interface SearchDealsRequestSortingCriteria {
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSortingCriteria
     */
    'field': SearchDealsRequestSortingCriteriaFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSortingCriteria
     */
    'sortOrder': SearchDealsRequestSortingCriteriaSortOrderEnum;
}

export const SearchDealsRequestSortingCriteriaFieldEnum = {
    issuedAt: 'ISSUED_AT',
    dealName: 'DEAL_NAME',
    amount: 'AMOUNT'
} as const;

export type SearchDealsRequestSortingCriteriaFieldEnum = typeof SearchDealsRequestSortingCriteriaFieldEnum[keyof typeof SearchDealsRequestSortingCriteriaFieldEnum];
export const SearchDealsRequestSortingCriteriaSortOrderEnum = {
    asc: 'ASC',
    desc: 'DESC'
} as const;

export type SearchDealsRequestSortingCriteriaSortOrderEnum = typeof SearchDealsRequestSortingCriteriaSortOrderEnum[keyof typeof SearchDealsRequestSortingCriteriaSortOrderEnum];


